"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tardigrades = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var ResourceType_1 = require("../../ResourceType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var Tardigrades = (function (_super) {
    __extends(Tardigrades, _super);
    function Tardigrades() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.TARDIGRADES,
            tags: [Tags_1.Tags.MICROBE],
            cost: 4,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            metadata: {
                cardNumber: '049',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 Microbe to this card.', function (eb) {
                        eb.empty().startAction.microbes(1);
                    }).br;
                    b.vpText('1 VP per 4 Microbes on this card.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.microbes(1, 4),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    Tardigrades.prototype.getVictoryPoints = function () {
        return Math.floor(this.resourceCount / 4);
    };
    Tardigrades.prototype.play = function () {
        return undefined;
    };
    Tardigrades.prototype.action = function (player) {
        player.addResourceTo(this);
        return undefined;
    };
    Tardigrades.prototype.canAct = function () {
        return true;
    };
    return Tardigrades;
}(Card_1.Card));
exports.Tardigrades = Tardigrades;
//# sourceMappingURL=Tardigrades.js.map